import { ICupom } from "../interface/ICupom";
import { calcularValoresComCupons } from "./calcularValoresComCupons";

/**
 * Calcula o valor do desconto de um cupom específico considerando os cupons já selecionados/aplicados
 * Isso é importante porque alguns cupons (como porcentagem) dependem do valor atual após outros descontos
 */
export const calcularDescontoCupomComCuponsSelecionados = (
    cupom: ICupom,
    valorTotalProdutos: number,
    valorFrete: number,
    cuponsJaAplicados: ICupom[] = []
): number => {
    // Calcular desconto total ANTES de incluir este cupom
    const valoresAntes = calcularValoresComCupons(
        { valorTotalProdutos, valorFrete },
        cuponsJaAplicados
    );
    const descontoTotalAntes = valoresAntes.valorDescontoTotal;

    // Calcular desconto total DEPOIS de incluir este cupom
    const cuponsComEste = [...cuponsJaAplicados, cupom];
    const valoresDepois = calcularValoresComCupons(
        { valorTotalProdutos, valorFrete },
        cuponsComEste
    );
    const descontoTotalDepois = valoresDepois.valorDescontoTotal;

    // O desconto deste cupom é a diferença
    return descontoTotalDepois - descontoTotalAntes;
};

